exports = module.exports = require("../../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"WorkServiceSelect.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/css-loader?{"sourceMap":true}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bf91db5","scoped":true,"hasInlineConfig":false}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Catalogs/WorkServices/WorkServiceSelect.vue
// module id = Yg1t
// module chunks = 0